import React from "react";

const Prods = () => {
  return (
    <div className="bg-white hover:shadow-2xl w-[300px] h-[400px] rounded-2xl overflow-hidden transition-all duration-150">
      <img
        src="/Images/chair.svg"
        alt="chair"
        className="w-full h-[80%] object-cover"
        width="800"
        height="100"
      />
      <div className="text-2xl h-[20%] flex items-center justify-center">
        Oudoor chairs
      </div>
    </div>
  );
};

export default Prods;
